module.exports = __webpack_public_path__ + "static/side-tile-34c285502192ff7252f6f505fd227c5e.png";